import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { FacilityTypeEnum } from '../contracts';

const GetFacilityTypesResponseDtoSchema = z.array(
  z.object({
    id: z.number(),
    name: FacilityTypeEnum,
  })
);

export type GetFacilityTypesResponseDto = z.infer<
  typeof GetFacilityTypesResponseDtoSchema
>;

export const getFacilityTypes = (config?: AxiosRequestConfig) => {
  return api
    .get('/facilities/facility-types', config)
    .then(responseContract(GetFacilityTypesResponseDtoSchema));
};
